export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Time: { input: any; output: any; }
};

export type Allergen = {
  __typename?: 'Allergen';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AllergenPresence {
  Contains = 'Contains',
  MayContain = 'MayContain'
}

export type FloatRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type Ingredient = {
  __typename?: 'Ingredient';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  processingLevel?: Maybe<ProcessingLevel>;
  unit: IngredientUnit;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type IngredientAllergen = {
  __typename?: 'IngredientAllergen';
  allergen: Allergen;
  id: Scalars['ID']['output'];
  presence: AllergenPresence;
};

export type IngredientFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum IngredientUnit {
  Gram = 'Gram',
  Milliliter = 'Milliliter',
  None = 'None'
}

export type IntRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProcessingLevel {
  MinimallyProcessed = 'MinimallyProcessed',
  Processed = 'Processed',
  UltraProcessed = 'UltraProcessed',
  Whole = 'Whole'
}

export type Query = {
  __typename?: 'Query';
  ingredients: Array<Ingredient>;
  recipe: Recipe;
  recipes: Array<Recipe>;
  searchRecipes: RecipeSearchResult;
};


export type QueryIngredientsArgs = {
  filter?: InputMaybe<IngredientFilter>;
};


export type QueryRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecipesArgs = {
  filter?: InputMaybe<RecipeFilter>;
};


export type QuerySearchRecipesArgs = {
  input: RecipeSearchInput;
};

export type Recipe = {
  __typename?: 'Recipe';
  allergens?: Maybe<Array<IngredientAllergen>>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  carbs?: Maybe<Scalars['Float']['output']>;
  category: RecipeCategory;
  consolidatedIngredients?: Maybe<Array<RecipeIngredient>>;
  cookingTimeMin?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Time']['output'];
  enrichmentStartTime?: Maybe<Scalars['Time']['output']>;
  fat?: Maybe<Scalars['Float']['output']>;
  fibers?: Maybe<Scalars['Float']['output']>;
  fiveADayPortions?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageID?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Array<RecipeIngredient>>;
  ingredientsHash?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  netCarbs?: Maybe<Scalars['Float']['output']>;
  openAIRequestID?: Maybe<Scalars['ID']['output']>;
  parentRecipeID?: Maybe<Scalars['ID']['output']>;
  plantDiversity?: Maybe<Scalars['Float']['output']>;
  preparationTimeMin?: Maybe<Scalars['Int']['output']>;
  proteins?: Maybe<Scalars['Float']['output']>;
  ratingCount: Scalars['Int']['output'];
  realOVoreScore?: Maybe<Scalars['Float']['output']>;
  recipeDescription?: Maybe<Scalars['String']['output']>;
  recipeVersion: Scalars['Int']['output'];
  serves: Scalars['Int']['output'];
  skillsRequirements?: Maybe<Scalars['Int']['output']>;
  steps?: Maybe<Array<RecipeStep>>;
  tags?: Maybe<Array<RecipeTag>>;
  type: RecipeType;
  updatedAt: Scalars['Time']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userRating?: Maybe<Scalars['Int']['output']>;
};

export enum RecipeCategory {
  Appetizer = 'Appetizer',
  Breakfast = 'Breakfast',
  Dessert = 'Dessert',
  Dinner = 'Dinner',
  Drink = 'Drink',
  Lunch = 'Lunch',
  Side = 'Side',
  Snack = 'Snack'
}

export type RecipeFilter = {
  category?: InputMaybe<RecipeCategory>;
  cuisineTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  customTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasIngredients?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  realOVoreScore?: InputMaybe<FloatRangeInput>;
  sort?: InputMaybe<RecipesSorting>;
  type?: InputMaybe<RecipeType>;
};

export type RecipeIngredient = {
  __typename?: 'RecipeIngredient';
  calories?: Maybe<Scalars['Float']['output']>;
  carbs?: Maybe<Scalars['Float']['output']>;
  fat?: Maybe<Scalars['Float']['output']>;
  fibers?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ingredient: Ingredient;
  ingredientQuantity?: Maybe<Scalars['Float']['output']>;
  netCarbs?: Maybe<Scalars['Float']['output']>;
  processingLevel?: Maybe<ProcessingLevel>;
  proteins?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  unit: RecipeIngredientUnit;
  unitName?: Maybe<Scalars['String']['output']>;
};

export enum RecipeIngredientUnit {
  Cup = 'Cup',
  Gram = 'Gram',
  Milliliter = 'Milliliter',
  None = 'None',
  Pinch = 'Pinch',
  Tablespoon = 'Tablespoon',
  Teaspoon = 'Teaspoon'
}

export type RecipeSearchInput = {
  category?: InputMaybe<RecipeCategory>;
  cuisineTagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  customTagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ingredientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nutrition?: InputMaybe<RecipeSearchNutritionFilterInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  skillsRequirements?: InputMaybe<Array<Scalars['Int']['input']>>;
  sort?: InputMaybe<RecipesSorting>;
  totalCookingTime?: InputMaybe<IntRangeInput>;
  type?: InputMaybe<RecipeType>;
};

export type RecipeSearchNutritionFilterInput = {
  calories?: InputMaybe<FloatRangeInput>;
  fat?: InputMaybe<FloatRangeInput>;
  fibre?: InputMaybe<FloatRangeInput>;
  netCarbs?: InputMaybe<FloatRangeInput>;
  plantDiversity?: InputMaybe<FloatRangeInput>;
  protein?: InputMaybe<FloatRangeInput>;
  realOVoreScore?: InputMaybe<FloatRangeInput>;
};

export type RecipeSearchResult = {
  __typename?: 'RecipeSearchResult';
  recipes: Array<Recipe>;
  suggestions: RecipeSearchSuggestions;
};

export type RecipeSearchSuggestion = {
  __typename?: 'RecipeSearchSuggestion';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RecipeSearchSuggestions = {
  __typename?: 'RecipeSearchSuggestions';
  cuisineTags: Array<RecipeSearchSuggestion>;
  customTags: Array<RecipeSearchSuggestion>;
  ingredients: Array<RecipeSearchSuggestion>;
};

export type RecipeStep = {
  __typename?: 'RecipeStep';
  description: Scalars['String']['output'];
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ingredients?: Maybe<Array<RecipeStepIngredient>>;
  stepNumber: Scalars['Int']['output'];
};

export type RecipeStepIngredient = {
  __typename?: 'RecipeStepIngredient';
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ingredient: Ingredient;
  ingredientQuantity?: Maybe<Scalars['Float']['output']>;
  processingLevel?: Maybe<ProcessingLevel>;
  quantity: Scalars['Float']['output'];
  unit: RecipeIngredientUnit;
};

export type RecipeTag = {
  __typename?: 'RecipeTag';
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tag: Tag;
};

export enum RecipeType {
  Fish = 'Fish',
  Meat = 'Meat',
  Vegan = 'Vegan',
  Veggie = 'Veggie'
}

export enum RecipesSorting {
  CaloriesAsc = 'CaloriesAsc',
  CaloriesDesc = 'CaloriesDesc',
  CookTimeAsc = 'CookTimeAsc',
  CreatedAtAsc = 'CreatedAtAsc',
  CreatedAtDesc = 'CreatedAtDesc',
  FibersDesc = 'FibersDesc',
  MostRelevant = 'MostRelevant',
  NameAsc = 'NameAsc',
  NameDesc = 'NameDesc',
  NetCarbsAsc = 'NetCarbsAsc',
  NetCarbsPercentageAsc = 'NetCarbsPercentageAsc',
  NetCarbsPercentageDesc = 'NetCarbsPercentageDesc',
  PlantDiversityDesc = 'PlantDiversityDesc',
  ProteinDesc = 'ProteinDesc',
  RatingAsc = 'RatingAsc',
  RatingDesc = 'RatingDesc',
  RealOVoreScoreAsc = 'RealOVoreScoreAsc',
  RealOVoreScoreDesc = 'RealOVoreScoreDesc',
  UpdatedAtAsc = 'UpdatedAtAsc',
  UpdatedAtDesc = 'UpdatedAtDesc',
  UserRatingDesc = 'UserRatingDesc'
}

export type Tag = {
  __typename?: 'Tag';
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: TagType;
};

export enum TagType {
  Auto = 'Auto',
  Cuisine = 'Cuisine',
  Custom = 'Custom'
}
